<template>
  <PageContainer class="PageContainer" :breadcrumbs="breadcrumbs">
    <Help />
  </PageContainer>
</template>

<script lang="ts">
import { useSeoMeta, definePageMeta, useHead, useRuntimeConfig } from '#imports'
import { defineNuxtComponent } from '#app'
import Help from "@/containers/Help";
import PageContainer from '@/containers/Page'

export default defineNuxtComponent({
  components: {
    Help,
    PageContainer,
  },
  async setup() {
    const { public: { APP_ENV } } = useRuntimeConfig()
    const title = '販売お問合せ窓口 - カーナベル'
    const description = "トレカ販売に関するカーナベルへのお問合せはこちらから。月曜〜土曜の17:00までにいただいたお問合せには当日中にメールにてご返信！"
    useSeoMeta({
      title,
      description,
      ogTitle: title,
      ogDescription: description,
      robots: APP_ENV==='production' ? 'index,follow' :'noindex,nofollow',
      twitterSite: '@ka_nabell_pcg',
      ogSiteName: 'ポケカ販売ならカーナベル！',
      ogUrl: 'https://sell.ka-nabell.com/help'
    })

    useHead({
      link: [
        {
          rel: 'canonical',
          href: 'https://sell.ka-nabell.com/help'
        }
      ]
    })

    definePageMeta({
      layout: 'simple'
    })

    const breadcrumbs = [
      {
        title: 'トレカ販売トップ',
        link: '/',
      },
      {
        title: '販売お問合せ窓口',
      }
    ]

    return {
      breadcrumbs,
    }
  }
})
</script>
